import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { CurrentReqState } from "@hooks/useRequestState";
import { CSSProps } from "@lib/types/generic";
import React from "react";

interface Props extends CSSProps {
  reqState?: CurrentReqState<any>;
  textOverride?: string;
}

export default function FormError(props: Props) {
  const { reqState, textOverride, ...cssProps } = props;

  if (textOverride != null) {
    return <Error text={textOverride} {...cssProps} />;
  } else if (reqState?.error != null) {
    return <Error text={reqState.error.toString()} {...cssProps} />;
  }

  return null;
}

interface ErrorProps extends CSSProps {
  text: string;
}

const Error = ({ className = "", id, style, text }: ErrorProps) => (
  <p
    className={`flex flex-row justify-center gap-2 mt-4 text-red-500 ${className}`}
    id={id}
    style={style}>
    <ExclamationCircleIcon className="w-6" />
    {text}
  </p>
);
